import axios from "axios"

const url = process.env.REACT_APP_URL

export const getFileFromBucket = async (path: string) => {
  try {
    let res = await axios.get(url + "/aws/getFileFromBucket", {
      params: {
        key: path
      }
    })
    if (res?.data) {
      return res.data
    }
  } catch (err) {
    console.log(err)
  }
}
